import { gql } from '@apollo/client';
import { USER_FRAGMENT } from '../fragments/userFragment';
import { AGENCY_FRAGMENT } from '../fragments/agencyFragment';
import { SESSION_AGENT_FRAGMENT } from '../fragments/agentFragment';

export const GET_SESSION_QUERY = gql`
  query GetSessionQuery {
    currentUser {
      ...UserFragment
      agent {
        ...AgentFragment
        agency {
          ...AgencyFragment
        }
      }
    }
    originalUser {
      ...UserFragment
      agent {
        ...AgentFragment
        id
        email
        firstName
        lastName
        fullName
        agency {
          id
          name
          status
        }
      }
    }
  }
  ${USER_FRAGMENT}
  ${SESSION_AGENT_FRAGMENT}
  ${AGENCY_FRAGMENT}
`;
